// components/WhatYouLearn.jsx
import React, { useState } from 'react';
import '../CSS/LandingWhatYouLearn.css';
import callImage from '../../assets/call.jpg';
import CapmEligibilityModal from './CapmEligibilityModal';

const CapmWhatYouLearn = ({ scrollToCalendar, openEligibilityModalCapm }) => {
  const [showEligibilityModalCapm, setShowEligibilityModalCapm] = useState(false);

  const handleEligibilityCompleteCapm = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModalCapm(false);

    // Rediriger vers l'inscription si recommandation PMP
    if (results.recommendation.certification === 'CAPM') {
      scrollToCalendar();
    }
  };

  return (
    <>
      <section className="landing-what-you-learn" id="programme" style={{ marginBottom: "-80px" }}>
        <div className="landing-contenir">
          <h2 className="landing-section-title">Ce que vous allez apprendre et accomplir</h2>
          <p className="landing-section-subtitle">
            Un parcours de certification CAPM<sup>®</sup> ne se limite pas à la préparation d’un examen. 
            Il vise à transformer votre manière de gérer les projets, de décider et de créer de la valeur 
            dans des environnements complexes. Vous allez découvrir tout au long du parcours les bonnes pratiques, 
            la logique du PMI ainsi que le fonctionnement de la certification CAPM.
          </p>

          {/* DEUX BLOCS SUR LA MÊME LIGNE */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '3rem',
            margin: '3rem 0'
          }}>
            {/* BLOC 1: CE QUE VOUS ALLEZ APPRENDRE */}
            <div className="landing-learn-block" style={{
              flex: '1',
              minWidth: '300px',
              backgroundColor: '#0a3764',
              color: 'white',
              padding: '2.5rem',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '200px',
                height: '200px',
                backgroundColor: 'rgba(123, 185, 255, 0.2)',
                borderRadius: '50%'
              }}></div>

              <h3 className="landing-block-title">
                Ce que vous allez apprendre
              </h3>

              <ul className="landing-learn-list">
                <li className="landing-list-item">
                  Maîtriser les <strong>bases du management de projet</strong>
                </li>

                <li className="landing-list-item">
                  Distinguer les <strong>différentes approches de gestion de projet</strong>
                </li>

                <li className="landing-list-item">
                  Choisir la <strong>méthode de travail la plus adaptée à votre projet</strong>
                </li>

                <li className="landing-list-item">
                  Aligner les solutions sur les <strong>objectifs de votre organisation</strong>
                </li>

                <li className="landing-list-item">
                  Maîtriser les <strong>activités clés du lancement d'un projet</strong> 
                </li>

                <li className="landing-list-item">
                  Appliquer une <strong>approche prédictive du management de projet</strong>
                </li>

                <li className="landing-list-item">
                  Adapter la <strong>planification du projet aux changements et aux nouvelles priorités</strong>
                </li>

                <li className="landing-list-item">
                  Piloter <strong>l'exécution, le suivi et la clôture du projet jusqu'à la livraison</strong>
                </li>
              </ul>
            </div>

            {/* BLOC 2: CE QUE VOUS ALLEZ ACCOMPLIR */}
            <div className="landing-accomplish-block" style={{
              flex: '1',
              minWidth: '300px',
              backgroundColor: '#94bf3e',
              color: 'white',
              padding: '2.5rem',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '-50px',
                width: '200px',
                height: '200px',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '50%'
              }}></div>

              <h3 className="landing-block-title">
                Ce que vous allez accomplir à l'issue du parcours
              </h3>

              <ul className="landing-accomplish-list">
                <li className="landing-list-item">
                  Passer les examens <strong>CAPM<sup>®</sup></strong> et <strong>PSM1</strong> avec clarté et sérénité
                </li>

                <li className="landing-list-item">
                  Parler un <strong>langage projet reconnu mondialement</strong>
                </li>

                <li className="landing-list-item">
                  Renforcer votre <strong>crédibilité professionnelle</strong> auprès des décideurs
                </li>

                <li className="landing-list-item">
                  Être immédiatement <strong>opérationnel</strong> sur des projets d'envergure
                </li>

                <li className="landing-list-item">
                  Améliorer significativement les <strong>taux de réussite des projets</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* NOUVEAU BLOC: PASSEZ AU NIVEAU SUPÉRIEUR */}
        <div className="landing-next-level-section" style={{
          backgroundImage: `url(${callImage.src || callImage})`,
        }}>
          {/* Overlay sombre pour mieux lire le texte */}
          <div className="landing-next-level-overlay"></div>

          <h3 className="landing-next-level-title">
            Prenez dès maintenant une longueur d'avance !
          </h3>

          <div className="landing-next-level-buttons">
            <button
              className="landing-eligibility-btn"
              onClick={openEligibilityModalCapm}
            >
              Vérifier si vous êtes éligible
            </button>

            <button className="landing-join-btn" onClick={scrollToCalendar}>
              <span className="landing-join-text-desktop">Rejoignez notre prochain parcours CAPM</span>
              <span className="landing-join-text-mobile">Rejoignez notre prochain parcours</span>
            </button>
          </div>
        </div>
      </section>

      {/* Modal d'éligibilité */}
      <CapmEligibilityModal
        isOpen={showEligibilityModalCapm}
        onClose={() => setShowEligibilityModalCapm(false)}
        onComplete={handleEligibilityCompleteCapm}
      />

      <style jsx>{`
        /* Styles généraux */
        .landing-block-title {
          font-size: 1.8rem;
          margin-bottom: 2rem;
          font-weight: 700;
          position: relative;
          z-index: 1;
          color: white;
        }
        
        .landing-learn-list, .landing-accomplish-list {
          padding-left: 1.5rem;
          margin: 0;
          position: relative;
          z-index: 1;
          color: white;
        }
        
        .landing-list-item {
          font-size: 1.1rem;
          line-height: 1.6;
          margin-bottom: 1rem;
          color: white;
        }
        
        /* Styles pour le bloc next-level - IDENTIQUE AUX AUTRES COMPOSANTS */
        .landing-next-level-section {
          margin: 4rem auto 2rem;
          padding: 3rem;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          color: white;
          border-radius: 0px;
          text-align: center;
          position: relative;
          overflow: hidden;
          max-width: 1000px;
        }
        
        .landing-next-level-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 0;
        }
        
        .landing-next-level-title {
          font-size: 2rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          position: relative;
          zIndex: 1;
          color: white;
        }
        
        .landing-next-level-buttons {
          position: relative;
          zIndex: 1;
          margin-top: 2rem;
          display: flex;
          justify-content: center;
          gap: 2rem;
          flex-wrap: wrap;
        }
        
        .landing-eligibility-btn, .landing-join-btn {
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border: none;
          border-radius: 0px;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 250px;
        }
        
        .landing-eligibility-btn {
          background-color: #94bf3e;
          color: white;
          border: 2px solid #94bf3e;
        }
        
        .landing-eligibility-btn:hover {
          background-color: #94bf3e;
          border-color: #f0f0f0;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(148, 191, 62, 0.3);
        }
        
        .landing-join-btn {
          background-color: #0a3764;
          color: white;
          border: 2px solid #0a3764;
        }
        
        .landing-join-btn:hover {
          background-color: #09407e;
          border-color: #09407e;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(10, 55, 100, 0.3);
        }
        
        /* Masquer le texte mobile par défaut */
        .landing-join-text-mobile {
          display: none;
        }
        
        /* Afficher le texte desktop par défaut */
        .landing-join-text-desktop {
          display: inline;
        }
        
        /* RESPONSIVE TABLET (768px - 1024px) */
        @media (max-width: 1024px) {
          .landing-block-title {
            font-size: 1.6rem;
            margin-bottom: 1.5rem;
          }
          
          .landing-list-item {
            font-size: 1.05rem;
            line-height: 1.5;
            margin-bottom: 0.8rem;
          }
          
          .landing-next-level-section {
            padding: 2.5rem;
            max-width: 900px;
          }
          
          .landing-next-level-title {
            font-size: 1.8rem;
          }
        }
        
        /* RESPONSIVE MOBILE (≤768px) */
        @media (max-width: 768px) {
          /* Ajustement de l'espacement entre les blocs */
          .landing-learn-block, .landing-accomplish-block {
            padding: 2rem;
            min-width: 100%;
          }
          
          .landing-block-title {
            font-size: 1.4rem;
            margin-bottom: 1.2rem;
          }
          
          .landing-list-item {
            font-size: 0.95rem;
            line-height: 1.5;
            margin-bottom: 0.7rem;
          }
          
          .landing-next-level-section {
            padding: 2rem 1.5rem;
            margin: 3rem auto 1.5rem;
            max-width: 100%;
          }
          
          .landing-next-level-title {
            font-size: 1.5rem;
            margin-bottom: 1rem;
            line-height: 1.4;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 1rem;
            align-items: center;
            justify-content: center;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            width: auto;
            max-width: none;
            padding: 0.9rem 1.5rem;
            font-size: 1rem;
            min-width: auto;
            flex: 1;
          }
          
          /* Cacher le texte complet sur mobile */
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* RESPONSIVE PETIT MOBILE (≤480px) */
        @media (max-width: 480px) {
          .landing-learn-block, .landing-accomplish-block {
            padding: 1.5rem;
          }
          
          .landing-block-title {
            font-size: 1.3rem;
            margin-bottom: 1rem;
          }
          
          .landing-list-item {
            font-size: 0.9rem;
            line-height: 1.5;
            margin-bottom: 0.6rem;
          }
          
          .landing-learn-list, .landing-accomplish-list {
            padding-left: 1.2rem;
          }
          
          .landing-next-level-section {
            padding: 1.5rem 1rem;
          }
          
          .landing-next-level-title {
            font-size: 1.3rem;
            line-height: 1.4;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 0.8rem;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.9rem;
            padding: 0.8rem 1rem;
            flex: 1;
            min-width: 120px;
          }
          
          /* Cacher le texte complet sur petit mobile */
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* RESPONSIVE TRÈS PETIT MOBILE (≤360px) */
        @media (max-width: 360px) {
          .landing-learn-block, .landing-accomplish-block {
            padding: 1.2rem;
          }
          
          .landing-block-title {
            font-size: 1.2rem;
          }
          
          .landing-list-item {
            font-size: 0.85rem;
            line-height: 1.4;
          }
          
          .landing-learn-list, .landing-accomplish-list {
            padding-left: 1rem;
          }
          
          .landing-next-level-section {
            padding: 1.2rem 0.8rem;
          }
          
          .landing-next-level-title {
            font-size: 1.2rem;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 0.5rem;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.8rem;
            padding: 0.7rem 0.8rem;
            min-width: 110px;
          }
          
          /* Cacher le texte complet sur très petit mobile */
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* Pour les écrans très larges (> 1200px) */
        @media (min-width: 1200px) {
          .landing-next-level-section {
            max-width: 1000px;
          }
          
          .landing-next-level-title {
            font-size: 2.2rem;
          }
        }
      `}</style>
    </>
  );
};

export default CapmWhatYouLearn;